import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

type Props = {
  children: JSX.Element;
  urlList: string[];
};

export function BlackList(props: Props) {
  const { children, urlList } = props;

  const [searchParams] = useSearchParams();

  const url = (searchParams.get('url') || '').toLocaleLowerCase();

  if (!url || urlList.includes(url)) {
    return <Navigate to="/terms-and-conditions" />;
  }

  return children;
}
